import React, { useEffect } from 'react';
import classNames from 'classnames';
import { reverse, clone } from 'ramda';
import { Link } from 'react-router-dom';
import { ambient } from '@aw_products/ambient-weather-common'
import bindAllActions from '../../common/bindAllActions'
import FormattedDataPoint from './FormattedDataPoint';
import { getContrastingTextColor } from '../../common/ambient/utils'
const { HST } = ambient
// import PropTypes from 'prop-types';

function WbgtGuidelineWidget ({ currentDevice, alertActions }) {
  const [mostRecentAi, setMostRecentAi] = React.useState(null)
  useEffect(() => {
    if (!currentDevice || !currentDevice.lastData) {
      return
    }
    if (mostRecentAi !== null) {
      return
    }
    setMostRecentAi(false)
    alertActions.fetchInstances({
      alertId: HST.ALERT_ID,
      deviceId: currentDevice._id,
      createdAt: {
        $gt: currentDevice.lastData.dateutc
      }
    })
      .then(what => {
        setMostRecentAi(what.data[0] || false)
      })
  }, [currentDevice, alertActions, mostRecentAi])
  let show = (
    <div className='no-guildeline'>
      <Link to='/devices#hst' className='btn btn-primary'>Configure Heat Stress Guideline</Link>
    </div>
  )
  if (currentDevice.settings.hst && currentDevice.settings.hst.guideline) {
    let guideline = currentDevice.settings.hst.customGuideline
    let levelLabel
    let modifier
    let name = 'Custom'
    const isCustom = currentDevice.settings.hst.guideline === 'custom'
    if (!isCustom) {
      guideline = HST.guidelines[currentDevice.settings.hst.guideline]
      name = guideline.label
      if (HST.guidelineIsMulti(guideline)) {
        const level = clone(guideline.guidelines.find(g => g.label === currentDevice.settings.hst.level))
        levelLabel = guideline.levelLabel
        guideline = level
      } else {
        guideline = clone(guideline.guidelines[0])
      }
      if (guideline.modifier && currentDevice.settings.hst.modifier) {
        modifier = guideline.modifier.choices.find(c => c.label === currentDevice.settings.hst.modifier)
        guideline.zones = guideline.zones.map(z => {
          z.above = z.above - modifier.offset
          return z
        })
      }
    }
    const value = mostRecentAi && moment(mostRecentAi.createdAt).valueOf() > currentDevice.lastData.dateutc ? mostRecentAi.data.wbgtf : currentDevice.lastData.wbgtf
    const zoneStyle = {}
    let zone = reverse(guideline.zones).find(t => value >= t.above)
    let link
    if (!zone) {
      zone = {
        label: 'No Active Zone',
        mitigation: 'N/A'
      }
    } else if (!isCustom) {
      link = HST.thresholdUrl(currentDevice.settings.hst.guideline, guideline.label, zone.label)
    }
    if (zone) {
      // Use zone.color if available (custom color), otherwise lookup by label
      let color = zone.color
      if (!color) {
        const colorObj = HST.colors.find(c => c.zoneLabel === zone.label)
        if (colorObj) {
          color = '#' + colorObj.bkgndColor
          zoneStyle.color = '#' + colorObj.textColor
        }
      } else {
        // For custom colors, calculate contrasting text color
        zoneStyle.color = getContrastingTextColor(color)
      }
      if (color) {
        zoneStyle.backgroundColor = color
      }
    }
    show = (
      <div className='device-wbgt-guideline'>
        <div className='name'>{name}</div>
        <div className={classNames('zone')} style={zoneStyle}>
          {zone.label}
          {/* <FormattedDataPoint value={value} type='wbgtf' skipConvert /> */}
        </div>
        <div className='mitigation'>
          <label>Mitigation</label>
          {link ? <a href={link} target='_blank'>{zone.mitigation}</a> : zone.mitigation}
        </div>
        <div className='bottom'>
          {levelLabel && (
            <div className='level'>
              <label>{levelLabel}</label>
              {link ? <a href={link} target='_blank'>{guideline.label}</a> : guideline.label}
            </div>
          )}
          {modifier && (
            <div className='modifier'>
              <label>{guideline.modifier.label}</label>
              {link ? <a href={link} target='_blank'>{modifier.label}</a> : modifier.label}
            </div>
          )}
        </div>
      </div>
    )
  }
  return (
    <div className='device-wbgt-guideline-widget'>
      {show}
    </div>
  );
};

export default bindAllActions(WbgtGuidelineWidget);

WbgtGuidelineWidget.propTypes = {};
WbgtGuidelineWidget.defaultProps = {};

WbgtGuidelineWidget.displayName = 'WbgtGuidelineWidget'
